import { OUTDATED_DEMAND_NOTE_NOTICE } from "../../config/reviewerApplicationEdit";

/**
 * Shown above the Demand Note form when a reviewer edited the application
 * after the Demand Note was last saved. Shared by the Level 1, 2 and 3
 * Demand Note screens so the wording and look stay the same on all three.
 * Renders nothing when the saved Demand Note is up to date.
 */
export function OutdatedDemandNoteNotice({
  savedDemandNote,
}: {
  savedDemandNote: { applicationEditedAfterSave?: boolean } | null | undefined;
}) {
  if (!savedDemandNote?.applicationEditedAfterSave) return null;

  return (
    <p className="mx-4 mb-4 rounded-lg border border-amber-400 bg-amber-50 p-3 text-base font-semibold text-amber-800">
      {OUTDATED_DEMAND_NOTE_NOTICE}
    </p>
  );
}
